import React from 'react'
import Button from '@material-ui/core/Button';

import profile from '../Media/Tiffany.JPG'

const Home = () => (
    <div className='home'>


        <h2 style={{marginBottom: '0px', textAlign:'left'}}>Theoretical Astrophysicist.</h2>
        <h2 style={{marginBottom: '0px', marginTop: '0px', textAlign:'center'}}>Observational Astronomer.</h2>
        <h2 style={{marginTop: '0px', textAlign:'right'}}>Outreach Specialist.</h2>

        <img className='img-rounded' alt='Profile' src={profile} style={{height:'auto',width:'90%', padding:'20px 0px 0px 5%'}}></img>
        <p>
            I currently have a NASA Postdoctoral Program Fellowship hosted at the Astroparticle Physics Lab at Goddard Space Flight Center.  My research focuses on the development and application of theoretical models for blazar jets. I earned my Ph.D. from George Mason University on the development of analytic and numerical particle transport for multi-wavelength blazar spectra.
        </p>
        <p>
            My primary research has historically focused on high-energy particle acceleration and emission
            modeling in blazar jets. I have also worked with ground based optical exoplanet observation,
            narrow band continuum AGN reverberation mapping observations, and line-locking simulations
            for AGN outflows with Cloudy software.
        </p>

   <Button href={"mailto: tiffanylewisphd@gmail.com"} target="_blank">Email</Button>


    </div>
)

export default Home



// WEBPACK FOOTER //
// ./src/Components/Home.js